import { pipe, toPairs, sortBy, last, map, first } from 'lodash/fp';
/**
 * Returns object's keys ordered by values assigned to them.
 *
 * @param {object} input - object to process
 *
 * @returns {Array} keys - object's keys ordered by values assigned to them
 *
 * @example
 * keysInOrder({ a: 2, b: 3, c: 1, d: 0 }) // returns ['d', 'c', 'a', 'b']
 */

export var keysInOrder = pipe([toPairs, sortBy(last), map(first)]);
export default keysInOrder;